<template>
  <div class="mt-2">
    <div class="w-full mt-4 mb-2">
      <Header v-model="filters" />
    </div>
    <div class="w-full mt-4 mb-2">
      <resumenTotales :filters="filters" />
    </div>
    <div class="w-full mt-4 mb-2">
      <graficaPatologia :filters="filters" />
    </div>
    <div class="w-full mt-4 mb-2">
      <topPacientes :filters="filters" />
    </div>
  </div>
</template>
<script>
import { defineAsyncComponent, reactive, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
export default {
  name: 'dashboardRips',
  components: {
    Header: defineAsyncComponent(
      () => import('./components/Header.vue')
    ),
    resumenTotales: defineAsyncComponent(
      () => import('./components/resumenTotales.vue')
    ),
    graficaPatologia: defineAsyncComponent(
      () => import('./components/graficaPatologia.vue')
    ),
    topPacientes: defineAsyncComponent(
      () => import('./components/topPacientes.vue')
    )
  },
  setup () {
    const store = useStore()
    const user = computed(() => store.getters['auth/getPeople'])
    const filters = reactive({
      year: '',
      month_start: '01',
      month_end: '12',
      createdby: user.value.id
    })

    onMounted(() => {
      filters.year = new Date().getFullYear()
    })
    return {
      filters
    }
  }
}
</script>
<style scoped>
</style>
